import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useState, useEffect } from 'react';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { CUSTOMER_KEY, DEFAULT_FULFILLMENT_DATA, FULFILLMENT_KEY, PAYMENT_SOURCE_KEY, TIP_KEY } from './use-checkout.constants';
import { ActionName } from '../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { useRecaptcha } from '../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import { ADD_QUANTITY } from '../../domains/checkout/CartSummary/components/CartItemSummary/components/CartItemQuantityButton/CartItemQuantityButton.constants';
import { DEFAULT_TIP_PERCENTAGE } from '../../domains/checkout/TipSelector/TipSelector.constants';
import { getDefaultFulfillmentTypeForOrder } from '../../modules/fulfillment/services';
import { LogRocket } from '../../services/analytics';
import { isOrderClosed } from '../../services/checkout';
import * as API from '../../utils/api';
export default function useCheckout(orderUuid, paymentChannel) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$defaultCheckoutD = _ref.defaultCheckoutData,
    defaultCheckoutData = _ref$defaultCheckoutD === void 0 ? {
      specialInstructions: '',
      tip: {
        tipPercentage: DEFAULT_TIP_PERCENTAGE
      }
    } : _ref$defaultCheckoutD,
    _ref$originalOrder = _ref.originalOrder,
    originalOrder = _ref$originalOrder === void 0 ? {} : _ref$originalOrder,
    checkoutUuidProp = _ref.checkoutUuid,
    cartHook = _ref.cartHook;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    executeRecaptcha = _useRecaptcha2[0],
    recaptchaLoaded = _useRecaptcha2[1];
  var _useState = useState(checkoutUuidProp),
    _useState2 = _slicedToArray(_useState, 2),
    checkoutUuid = _useState2[0],
    setCheckoutUuid = _useState2[1];
  var _useState3 = useState(_cloneDeep(originalOrder)),
    _useState4 = _slicedToArray(_useState3, 2),
    order = _useState4[0],
    setOrder = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    editingCheckoutData = _useState6[0],
    setEditingCheckoutData = _useState6[1];
  var _useState7 = useState(_objectSpread(_objectSpread({}, _cloneDeep(defaultCheckoutData)), {}, {
      fulfillment: _objectSpread({}, DEFAULT_FULFILLMENT_DATA)
    })),
    _useState8 = _slicedToArray(_useState7, 2),
    checkoutData = _useState8[0],
    setCheckoutData = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    checkoutComplete = _useState10[0],
    setCheckoutComplete = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    checkoutLoading = _useState12[0],
    setCheckoutLoading = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    checkoutDisabled = _useState14[0],
    setCheckoutDisabled = _useState14[1];
  var _useState15 = useState({
      error: false
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    checkoutError = _useState16[0],
    setCheckoutError = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    unauthorized = _useState18[0],
    setUnauthorized = _useState18[1];
  var setNewOrderCart = cartHook.setNewOrder,
    clearCart = cartHook.clearCart,
    sessionToken = cartHook.orderSessionToken;
  var _ref2 = order || {},
    _ref2$line_items = _ref2.line_items,
    items = _ref2$line_items === void 0 ? [] : _ref2$line_items;
  useEffect(function () {
    LogRocket.init();
  }, []);
  function handleCheckoutError(e) {
    setCheckoutError({
      error: true,
      message: API.getErrorMessage(e)
    });
    setCheckoutLoading(false);
    var status = +_get(e, 'response.status', 400);
    if (status === 401 || status === 403 || status === 404) {
      clearCart();
      setUnauthorized(true);
      return;
    }
    LogRocket.captureError(e);
    throw e;
  }
  function executeCheckoutFunction(_x, _x2) {
    return _executeCheckoutFunction.apply(this, arguments);
  }
  function _executeCheckoutFunction() {
    _executeCheckoutFunction = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(asyncFunction, actionName) {
      var recaptchaToken, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setCheckoutLoading(true);
            setCheckoutError({
              error: false
            });
            _context.prev = 2;
            if (!actionName) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return executeRecaptcha(actionName);
          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;
          case 9:
            _context.t0 = null;
          case 10:
            recaptchaToken = _context.t0;
            _context.next = 13;
            return asyncFunction(recaptchaToken);
          case 13:
            response = _context.sent;
            setCheckoutLoading(false);
            return _context.abrupt("return", response);
          case 18:
            _context.prev = 18;
            _context.t1 = _context["catch"](2);
            return _context.abrupt("return", handleCheckoutError(_context.t1));
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 18]]);
    }));
    return _executeCheckoutFunction.apply(this, arguments);
  }
  function startCheckout() {
    return _startCheckout.apply(this, arguments);
  }
  function _startCheckout() {
    _startCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(recaptchaToken) {
                var nextOrder, checkout, checkoutResponseUuid, _ref5, tip, attributesToken, attributes;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return API.getOrder(orderUuid, sessionToken);
                    case 2:
                      nextOrder = _context2.sent;
                      if (isOrderClosed(nextOrder)) {
                        _context2.next = 19;
                        break;
                      }
                      if (!(_isEmpty(checkoutUuid) && _isEmpty(checkoutUuidProp))) {
                        _context2.next = 10;
                        break;
                      }
                      _context2.next = 7;
                      return API.startCheckout(orderUuid, recaptchaToken, sessionToken);
                    case 7:
                      checkout = _context2.sent;
                      checkoutResponseUuid = checkout.uuid;
                      setCheckoutUuid(checkoutResponseUuid);
                    case 10:
                      _ref5 = nextOrder || {}, tip = _ref5.tip_total;
                      if (!(+tip > 0)) {
                        _context2.next = 19;
                        break;
                      }
                      _context2.next = 14;
                      return executeRecaptcha(ActionName.SET_ORDER_ATTRIBUTES);
                    case 14:
                      attributesToken = _context2.sent;
                      attributes = checkoutData[TIP_KEY];
                      _context2.next = 18;
                      return API.updateOrderAttributes(orderUuid, attributes, attributesToken, sessionToken);
                    case 18:
                      nextOrder = _context2.sent;
                    case 19:
                      setOrder(nextOrder);
                      setCheckoutData(function (prevData) {
                        return _objectSpread(_objectSpread({}, prevData), {}, {
                          fulfillment: _objectSpread(_objectSpread({}, DEFAULT_FULFILLMENT_DATA), {}, {
                            fulfillmentType: getDefaultFulfillmentTypeForOrder(nextOrder)
                          })
                        });
                      });
                    case 21:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x14) {
                return _ref4.apply(this, arguments);
              };
            }(), ActionName.START_ORDER_CHECKOUT);
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _startCheckout.apply(this, arguments);
  }
  function acceptOrderAdjustments(_x3) {
    return _acceptOrderAdjustments.apply(this, arguments);
  }
  function _acceptOrderAdjustments() {
    _acceptOrderAdjustments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(adjustments) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return API.acceptOrderAdjustments(orderUuid, adjustments, recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context4.sent;
                      setOrder(nextOrder);
                      setNewOrderCart(nextOrder);
                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x15) {
                return _ref6.apply(this, arguments);
              };
            }(), ActionName.ACCEPT_ORDER_ADJUSTMENTS);
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _acceptOrderAdjustments.apply(this, arguments);
  }
  function closeCheckout() {
    return _closeCheckout.apply(this, arguments);
  }
  function _closeCheckout() {
    _closeCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(recaptchaToken) {
                var _yield$API$closeCheck, nextOrder;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return API.closeCheckout(checkoutUuid, recaptchaToken, sessionToken);
                    case 2:
                      _yield$API$closeCheck = _context6.sent;
                      nextOrder = _yield$API$closeCheck.order;
                      setOrder(nextOrder);
                      clearCart();
                      setCheckoutComplete(true);
                    case 7:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x16) {
                return _ref7.apply(this, arguments);
              };
            }(), ActionName.CLOSE_ORDER_CHECKOUT);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _closeCheckout.apply(this, arguments);
  }
  function updateOrderCustomer() {
    return _updateOrderCustomer.apply(this, arguments);
  }
  function _updateOrderCustomer() {
    _updateOrderCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var customer;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            customer = checkoutData[CUSTOMER_KEY];
            _context9.next = 3;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(recaptchaToken) {
                var nextOrder, firstName, lastName, email;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _context8.next = 2;
                      return API.updateOrderCustomer(orderUuid, customer, recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context8.sent;
                      setOrder(nextOrder);
                      firstName = customer.firstName, lastName = customer.lastName, email = customer.email;
                      LogRocket.identify(email, {
                        name: "".concat(firstName, " ").concat(lastName),
                        email: email
                      });
                    case 6:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              return function (_x17) {
                return _ref8.apply(this, arguments);
              };
            }(), ActionName.SET_ORDER_CUSTOMER);
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _updateOrderCustomer.apply(this, arguments);
  }
  function updateOrderFulfillment() {
    return _updateOrderFulfillment.apply(this, arguments);
  }
  function _updateOrderFulfillment() {
    _updateOrderFulfillment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var forcedFulfillmentType,
        fulfillmentType,
        finalFulfillmentType,
        fulfillmentMethods,
        fulfillmentData,
        _args11 = arguments;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            forcedFulfillmentType = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : undefined;
            fulfillmentType = checkoutData[FULFILLMENT_KEY].fulfillmentType;
            finalFulfillmentType = forcedFulfillmentType || fulfillmentType;
            fulfillmentMethods = _get(order, 'fulfillment_methods', []).filter(function (method) {
              return method.type === finalFulfillmentType;
            });
            fulfillmentData = {
              method: _get(fulfillmentMethods, '[0].id', null)
            };
            _context11.next = 7;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.next = 2;
                      return API.updateOrderFulfillment(orderUuid, fulfillmentData, recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context10.sent;
                      setOrder(nextOrder);
                    case 4:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return function (_x18) {
                return _ref9.apply(this, arguments);
              };
            }(), ActionName.SET_ORDER_FULFILLMENT);
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _updateOrderFulfillment.apply(this, arguments);
  }
  function updateOrderFulfillmentRecipient() {
    return _updateOrderFulfillmentRecipient.apply(this, arguments);
  }
  function _updateOrderFulfillmentRecipient() {
    _updateOrderFulfillmentRecipient = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) switch (_context12.prev = _context12.next) {
                    case 0:
                      _context12.next = 2;
                      return API.updateOrderFulfillmentRecipient(orderUuid, checkoutData[FULFILLMENT_KEY], recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context12.sent;
                      setOrder(nextOrder);
                    case 4:
                    case "end":
                      return _context12.stop();
                  }
                }, _callee12);
              }));
              return function (_x19) {
                return _ref10.apply(this, arguments);
              };
            }(), ActionName.SET_ORDER_FULFILLMENT);
          case 2:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _updateOrderFulfillmentRecipient.apply(this, arguments);
  }
  function updateOrderAttributes(_x4) {
    return _updateOrderAttributes.apply(this, arguments);
  }
  function _updateOrderAttributes() {
    _updateOrderAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(attributes) {
      var finalAttributes;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            finalAttributes = attributes || checkoutData[TIP_KEY];
            _context15.next = 3;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      _context14.next = 2;
                      return API.updateOrderAttributes(orderUuid, finalAttributes, recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context14.sent;
                      setOrder(nextOrder);
                    case 4:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              }));
              return function (_x20) {
                return _ref11.apply(this, arguments);
              };
            }(), ActionName.SET_ORDER_ATTRIBUTES);
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _updateOrderAttributes.apply(this, arguments);
  }
  function setOrderPaymentSource(_x5) {
    return _setOrderPaymentSource.apply(this, arguments);
  }
  function _setOrderPaymentSource() {
    _setOrderPaymentSource = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(paymentSource) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            payload = paymentSource || checkoutData[PAYMENT_SOURCE_KEY];
            _context17.next = 3;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      _context16.next = 2;
                      return API.setOrderPaymentSource(orderUuid, payload, recaptchaToken, sessionToken);
                    case 2:
                      nextOrder = _context16.sent;
                      setOrder(nextOrder);
                    case 4:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x21) {
                return _ref12.apply(this, arguments);
              };
            }(), ActionName.SET_ORDER_PAYMENT_SOURCE);
          case 3:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    return _setOrderPaymentSource.apply(this, arguments);
  }
  function getOrderItem(_x6) {
    return _getOrderItem.apply(this, arguments);
  }
  function _getOrderItem() {
    _getOrderItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(itemUuid) {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", executeCheckoutFunction(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
              return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    return _context18.abrupt("return", API.getOrderLineItem(itemUuid, sessionToken));
                  case 1:
                  case "end":
                    return _context18.stop();
                }
              }, _callee18);
            }))));
          case 1:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _getOrderItem.apply(this, arguments);
  }
  function getOrderItemOptions(_x7) {
    return _getOrderItemOptions.apply(this, arguments);
  }
  function _getOrderItemOptions() {
    _getOrderItemOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(itemUuid) {
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", executeCheckoutFunction(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
              return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) switch (_context20.prev = _context20.next) {
                  case 0:
                    return _context20.abrupt("return", API.getOrderLineItemOptions(itemUuid, sessionToken));
                  case 1:
                  case "end":
                    return _context20.stop();
                }
              }, _callee20);
            }))));
          case 1:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    return _getOrderItemOptions.apply(this, arguments);
  }
  function deleteOrderItem(_x8) {
    return _deleteOrderItem.apply(this, arguments);
  }
  function _deleteOrderItem() {
    _deleteOrderItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(index) {
      var lineItems, lineItem, lineItemId;
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            lineItems = order.line_items;
            lineItem = lineItems[index];
            if (lineItem) {
              _context23.next = 4;
              break;
            }
            return _context23.abrupt("return");
          case 4:
            lineItemId = lineItem.uuid;
            _context23.next = 7;
            return executeCheckoutFunction(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
              var nextOrder;
              return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                while (1) switch (_context22.prev = _context22.next) {
                  case 0:
                    _context22.next = 2;
                    return API.deleteOrderLineItem(lineItemId, sessionToken);
                  case 2:
                    _context22.next = 4;
                    return API.getOrder(orderUuid, sessionToken);
                  case 4:
                    nextOrder = _context22.sent;
                    setOrder(nextOrder);
                    setNewOrderCart(nextOrder);
                  case 7:
                  case "end":
                    return _context22.stop();
                }
              }, _callee22);
            })));
          case 7:
          case "end":
            return _context23.stop();
        }
      }, _callee23);
    }));
    return _deleteOrderItem.apply(this, arguments);
  }
  function deleteOrderItemByUuid(_x9) {
    return _deleteOrderItemByUuid.apply(this, arguments);
  }
  function _deleteOrderItemByUuid() {
    _deleteOrderItemByUuid = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(uuid) {
      var index;
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            index = items.findIndex(function (_ref16) {
              var currentUuid = _ref16.uuid;
              return currentUuid === uuid;
            });
            _context24.next = 3;
            return deleteOrderItem(index);
          case 3:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
    return _deleteOrderItemByUuid.apply(this, arguments);
  }
  function updateOrderItem(_x10, _x11) {
    return _updateOrderItem.apply(this, arguments);
  }
  function _updateOrderItem() {
    _updateOrderItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(newItem, index) {
      var lineItems, lineItem, lineItemId;
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            lineItems = order.line_items;
            lineItem = lineItems[index];
            lineItemId = lineItem.uuid;
            _context26.next = 5;
            return executeCheckoutFunction(/*#__PURE__*/function () {
              var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(recaptchaToken) {
                var nextOrder;
                return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                  while (1) switch (_context25.prev = _context25.next) {
                    case 0:
                      _context25.next = 2;
                      return API.updateOrderLineItem(lineItemId, newItem, recaptchaToken, sessionToken);
                    case 2:
                      _context25.next = 4;
                      return API.getOrder(orderUuid, sessionToken);
                    case 4:
                      nextOrder = _context25.sent;
                      setOrder(nextOrder);
                      setNewOrderCart(nextOrder);
                    case 7:
                    case "end":
                      return _context25.stop();
                  }
                }, _callee25);
              }));
              return function (_x22) {
                return _ref17.apply(this, arguments);
              };
            }(), ActionName.UPDATE_ORDER_ITEM);
          case 5:
          case "end":
            return _context26.stop();
        }
      }, _callee26);
    }));
    return _updateOrderItem.apply(this, arguments);
  }
  function updateOrderItemQuantity(_x12, _x13) {
    return _updateOrderItemQuantity.apply(this, arguments);
  }
  function _updateOrderItemQuantity() {
    _updateOrderItemQuantity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27(type, index) {
      var lineItems, lineItem, quantity, quantityDelta, payload;
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            lineItems = order.line_items;
            lineItem = lineItems[index];
            quantity = lineItem.quantity;
            quantityDelta = type === ADD_QUANTITY ? 1 : -1;
            payload = {
              quantity: quantity + quantityDelta
            };
            return _context27.abrupt("return", updateOrderItem(payload, index));
          case 6:
          case "end":
            return _context27.stop();
        }
      }, _callee27);
    }));
    return _updateOrderItemQuantity.apply(this, arguments);
  }
  function onCheckoutDataChange(_ref3) {
    var value = _ref3.value,
      name = _ref3.name;
    setCheckoutData(function (previousCheckoutData) {
      return _objectSpread(_objectSpread({}, previousCheckoutData), {}, _defineProperty({}, name, value));
    });
  }
  function clearErrors() {
    setCheckoutError({
      error: false,
      message: ''
    });
  }
  function resetCheckout() {
    clearErrors();
    setCheckoutData(defaultCheckoutData);
    if (checkoutComplete) {
      setCheckoutComplete(false);
    }
  }
  return {
    checkoutData: checkoutData,
    onCheckoutDataChange: onCheckoutDataChange,
    editingCheckoutData: editingCheckoutData,
    setEditingCheckoutData: setEditingCheckoutData,
    order: order,
    getOrderItem: getOrderItem,
    getOrderItemOptions: getOrderItemOptions,
    deleteOrderItem: deleteOrderItem,
    deleteOrderItemByUuid: deleteOrderItemByUuid,
    updateOrderItem: updateOrderItem,
    updateOrderItemQuantity: updateOrderItemQuantity,
    updateOrderCustomer: updateOrderCustomer,
    updateOrderFulfillment: updateOrderFulfillment,
    updateOrderFulfillmentRecipient: updateOrderFulfillmentRecipient,
    setOrderPaymentSource: setOrderPaymentSource,
    updateOrderAttributes: updateOrderAttributes,
    startCheckout: startCheckout,
    acceptOrderAdjustments: acceptOrderAdjustments,
    closeCheckout: closeCheckout,
    checkoutComplete: checkoutComplete,
    checkoutDisabled: checkoutLoading || checkoutDisabled,
    setCheckoutDisabled: setCheckoutDisabled,
    checkoutLoading: checkoutLoading || !recaptchaLoaded,
    setCheckoutLoading: setCheckoutLoading,
    checkoutError: checkoutError,
    unauthorized: unauthorized,
    clearErrors: clearErrors,
    resetCheckout: resetCheckout,
    recaptchaLoaded: recaptchaLoaded
  };
}